import React from 'react';
import './App.css';
import Header from './Header';
import About from './About';
import HomePage from './HomePage'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SafetyTraining from './SafetyTraining';
import Faq from './Faq';
import Pricing from './Pricing';
import LifeSaving from './Lifesaving';
import Login from './login';
import Signup from './Signup';
import Dashboard from './Dashboard';
import DrivingPro from './DrivingPro';
import ContactForm from './Form';
import CheckoutForm from './CheckoutForm';
import CheckoutPage from './ProductPage';
import SuccessPage from './SuccessPayment';
import GamePlay from './PlayGame';
import GameVids from './GameVid';
import Fundamental from './Fundamentals';
import VRInstruction from './VRInstruction';
import ComingSoon from './ComingSoon';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import AdminPage from './AdminPage';
import Footer from './Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <main>
            <Routes>
              <Route path="/" element={<> <Header/> <HomePage /> </>} />
              <Route path="/life-saving" element={<> <Header/> <LifeSaving /> </>}/>
              <Route path="/pricing" element={<> <Header/> <Pricing /> </>} />
              <Route path="/safetytraining" element={<> <Header/>  <SafetyTraining/> </>} />
              <Route path="/driving-pro" element={<><Header/> <DrivingPro/> </>}/>
              <Route path="/fundamentals" element={<><Header/> <Fundamental/></>} />
              <Route path="/faq" element={<> <Header/> <Faq /> </>}/>
              <Route path="/about" element={<> <Header/> <About /> </>}/>
              <Route path="/login" element={<> <Header/><Login />  </>}/>
              <Route path="/signup" element={<> <Header/><Signup />  </>}/>
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
              <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>}/>
              <Route path="/contact" element={<><Header/><ContactForm /> </>} />
              <Route path="/checkout" element={<><Header/><CheckoutForm/></>}/>
              <Route path="/success" element={<><Header/> <SuccessPage/></>} />
              <Route path="/gameplay" element={<><Header/> <GamePlay/></>} />
              <Route path="/module-videos" element={<><Header/> <GameVids/></>} />
              <Route path="/installation-guide" element={<><Header/> <VRInstruction/></>} />
              <Route path="/pclicense" element={<><Header/> <CheckoutPage/></>} />
              <Route path="/comingsoon" element={<><Header/> <ComingSoon/></>} />
            </Routes>
            <Footer />
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
